export const finishTranslations = {
  none: [
    'None',
    'Ninguno'
  ],
  abs: ['ABS'],
  'abs-zinc': [
    'ABS with Zinc Cap & Brass Core',
    'ABS con Tapa de Zinc y Núcleo de Latón'
  ],
  black: [
    'Black',
    'Negro'
  ],
  'brushed-nickel': [
    'Brushed Nickel',
    'Níquel Cepillado',
    '镀镍拉丝'
  ],
  'brushed-stainless': [
    'Brushed Stainless',
    'Inoxidable Cepillado',
    '不锈钢拉丝'
  ],
  graphite: [
    'Graphite',
    'Grafito',
    '石墨'
  ],
  'gun-metal': [
    'Gun Metal',
    'Gris Acero'
  ],
  'matte-black': [
    'Matte Black',
    'Negro Mate',
    '哑光黑'
  ],
  'matte-white': [
    'Matte White',
    'Blanco Mate',
    '哑光白'
  ],
  'off-white': [
    'Off-White',
    'Blanquecino'
  ],
  'polished-brass': [
    'Polished Brass',
    'Latón Pulido',
    '抛光黄铜'
  ],
  'polished-chrome': [
    'Polished Chrome',
    'Cromo Pulido',
    '抛光铬'
  ],
  'polished-white': [
    'Polished White',
    'Blanco Pulido'
  ],
  'rough-brass': [
    'Rough Brass',
    'Latón Burdo'
  ],
  'stainless-steel': [
    'Stainless Steel',
    '304 Stainless Steel',
    'Acero Inoxidable'
  ],
  white: [
    'White',
    'Blanco'
  ],
  'white-epoxy': [
    'White Epoxy',
    'Epoxi Blanco'
  ],
  gray: [
    'Gray',
    'Gris'
  ],
  tan: [
    'Tan',
    'Bronceado'
  ],
  brown: [
    'Brown',
    'Marron'
  ],
  green: [
    'Green',
    'Verde'
  ],
  yellow: [
    'Yellow',
    'Amarillo'
  ],
  blue: [
    'Blue',
    'Azul'
  ],
  red: [
    'Red',
    'Rojo'
  ],
  pink: [
    'Pink',
    'Rosa'
  ],
  orange: [
    'Orange',
    'Naranja'
  ],
  purple: [
    'Purple',
    'Moradoe'
  ]
};

export function getFinishClassName(finish) {
  return Object.keys(finishTranslations).find(key => {
    if (finishTranslations[key].includes(finish)) {
      return key;
    }
  });
}
